import { Award, ClipboardPen, FileSpreadsheet } from 'lucide-react'
import { RequirePermission } from '@/features/auth/guards'
import { ExamDetailPage } from '@/pages/exams/ExamDetailPage'
import { ExamReportCardPage } from '@/pages/exams/ExamReportCardPage'
import { ExamsListPage } from '@/pages/exams/ExamsListPage'
import { FamilyResultsPage } from '@/pages/exams/FamilyResultsPage'
import { GradingScalesPage } from '@/pages/exams/GradingScalesPage'
import { StaffMarksEntryPage } from '@/pages/exams/StaffMarksEntryPage'
import type { AppModule } from '../moduleRegistry'

export const module: AppModule = {
  id: 'exams',
  schoolModule: 'exams',
  routes: {
    admin: [
      {
        path: 'exams',
        element: <RequirePermission permission="exams.view" />,
        children: [
          { index: true, element: <ExamsListPage /> },
          { path: 'grading-scales', element: <GradingScalesPage /> },
          { path: ':id', element: <ExamDetailPage /> },
          { path: ':id/students/:studentId', element: <ExamReportCardPage /> },
        ],
      },
    ],
    staff: [
      {
        path: 'marks',
        element: (
          <RequirePermission permission="marks.enter">
            <StaffMarksEntryPage />
          </RequirePermission>
        ),
      },
    ],
    family: [{ path: 'results', element: <FamilyResultsPage /> }],
  },
  nav: {
    admin: [
      {
        group: 'Academics',
        order: 50,
        item: {
          label: 'Examinations',
          to: '/admin/exams',
          icon: FileSpreadsheet,
          permission: 'exams.view',
          children: [
            {
              label: 'Exams',
              to: '/admin/exams',
              permission: 'exams.view',
              end: true,
              keywords: 'tests assessments marks results tabulation report card',
            },
            {
              label: 'Grading scales',
              to: '/admin/exams/grading-scales',
              permission: 'exams.view',
              keywords: 'grades gpa bands letter',
            },
          ],
        },
      },
    ],
    staff: [
      {
        order: 20,
        item: {
          label: 'Marks entry',
          to: '/staff/marks',
          icon: ClipboardPen,
          permission: 'marks.enter',
          keywords: 'grades exams gradebook',
        },
      },
    ],
    family: [
      {
        order: 25,
        item: {
          label: 'Results',
          to: '/portal/results',
          icon: Award,
          keywords: 'report card grades exams marks',
        },
      },
    ],
  },
}
